// Eligibility gate for the scatter tool's axis pickers. v1 is
// intentionally narrow:
//   - Material catalog entries only (derived / window / comparison
//     have non-trivial aggregation semantics at non-leaf groupings).
//   - measureKind must be non-null (the column has to be a number that
//     means something on a continuous axis).
//
// Both rules are easy to relax later -- they're not constraints of the
// underlying request shape, just guardrails against surfacing axes
// that would render confusing charts.

import { COLUMN_CATALOG_MAP } from '../../../lib/constants'
import { effectiveFormat } from '../../../lib/effectiveFormat'

function getCatalog (columnInstance) {
  if (!columnInstance) return null
  return COLUMN_CATALOG_MAP[columnInstance.columnType] || null
}

export function isScatterEligible (columnInstance) {
  const catalog = getCatalog(columnInstance)
  if (!catalog) return false
  if (catalog.kind && catalog.kind !== 'material') return false
  if (!catalog.measureKind) return false
  return true
}

/**
 * Join `config.columns` with `columnDefinitions` (which carries the
 * grid's header / format) and produce the set of axis options the
 * AxisPicker offers. Mirrors `deriveMeasureOptions` in `AllocationTool`
 * but unlocked beyond `currency` -- scatter accepts any numeric
 * measureKind.
 *
 * @returns Array<{ columnInstance, label, valueFormat, measureKind }>
 */
export function deriveAxisOptions (config, columnDefinitions, prefs) {
  const defsById = new Map((columnDefinitions || []).map(d => [d.accessorKey, d]))
  const out = []
  for (const col of config?.columns || []) {
    if (!isScatterEligible(col)) continue
    const def = defsById.get(col.id)
    if (!def) continue
    out.push({
      columnInstance: col,
      label: def.header,
      valueFormat: effectiveFormat(def.format, def.measureKind, prefs),
      measureKind: def.measureKind
    })
  }
  return out
}
